const defaultState = {
	//Basic
	defaultPlant: 'HUV1',
	commCdType: '',
	commCdList: '',
	currentPage: '0',
	pageUnit: '10',

	//Main
	categorys: [
		{ label: 'All', value: '' },
		{ label: '프로젝트관련', value: '프로젝트관련' },
		{ label: '공통FW', value: '공통FW' },
		{ label: '메인도메인', value: '메인도메인' },
		{ label: '공통도메인', value: '공통도메인' }
	],
	guideBoardList: [],
	vers: [],
	dtlCategorys: [],
	ver: '',
	category: '',
	dtlCategory: '',
	kwd: '',
	content: '',

	searchParams: {
		plantCd: 'HVS1',
		ver: '',
		category: '',
		dtlCategory: '',
		kwd: ''
	},

	groups: {
		currentPage: 0,
		pageUnit: 10,
		totalSize: 0,
		data: []
	},

	//Modal
	GuideBoardModal: false,
	GuideBoardModalValue: {
		flg: 'I',
		boardNo: '',
		ver: '',
		category: '',
		dtlCategory: '',
		title: '',
		regId: '',
		fileList: [],
		delList: '|', // file에 대한 정보를 List 형태로 넘기는 것 확인 필요.. 현재는 multipart type으로 넘길 때 list를 같이 넘겨 object로 변환하는 것이 불가한 것으로 보여 file의 name을 string으로 붙여서 보냄..
		imgList: [],
		conts: `1. 변경된 원인/사유 : 

2. FW버전변경/소스변경/데이터추가 : 

3. 상세 내용 : 

4. 개선되는 효과 : `
	},

	GuideBoardDetail: false,
	GuideBoardDetailValue: {
		boardNo: '',
		ver: '',
		category: '',
		dtlCategory: '',
		title: '',
		conts: '',
		regId: '',
		fileList: [],
		delList: '|',
		imgList: []
	}
};
export default {
	...JSON.parse(JSON.stringify(defaultState))
};
export { defaultState };
